<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />

  <div class="page">

    <div v-if="items.some(el => el.stato_interno == 'In sospensione') && type == 'sospensioni'">
       <Message severity="warn"> 
        Attenzione ci sono 
          {{items.filter(el => el.stato_interno == 'In sospensione').reduce(acc => acc + 1, 0)}}
         forniture già nello stato {{type}}
      </Message>
    </div>

    <div v-if="items.some(el => el.stato_interno == 'In riattivazione') && type == 'riattivazioni'">
       <Message severity="warn"> 
        Attenzione ci sono 
          {{items.filter(el => el.stato_interno == 'In riattivazione').reduce(acc => acc + 1, 0)}}
         forniture già nello stato {{type}}
      </Message>
    </div>

    <div v-if="items.some(el => moment(el.data_fine).isBefore(moment(), 'day') || !el.data_fine)">
       <Message severity="warn"> 
        Attenzione ci sono 
          {{items.filter(el => moment(el.data_fine).isBefore(moment(), 'day') || !el.data_fine).reduce(acc => acc + 1, 0)}}
         forniture già uscite
      </Message>
    </div>

     <div v-if="items.some(el => el.disalimentabile == 'N')">
       <Message severity="warn"> 
        Attenzione ci sono 
          {{items.filter(el => el.disalimentabile == 'N').reduce(acc => acc + 1, 0)}}
         forniture non disalimentabili
      </Message>
    </div>

    <div v-if="items.some(el => el.udd && el.udd.toUpperCase().includes('ANTARES')) && moment(new Date()).day() != 1">
       <Message severity="warn"> 
        Attenzione ci sono 
          {{items.filter(el => el.udd.toUpperCase().includes('ANTARES')).reduce(acc => acc + 1, 0)}}
         forniture con udd ANTARES che permette l'invio solo il lunedì
      </Message>
    </div>

    <div v-if="items.some(el => el.error == true)">
       <Message severity="error"> 
        Attenzione ci sono 
          {{items.filter(el => el.error == true).reduce(acc => acc + 1, 0)}}
         forniture con fornitore non configurato
      </Message>
    </div>

    <DataTable :value="items" v-model:selection="selectedItems" :filters="filters" dataKey="id" responsiveLayout="scroll" :rowClass="rowClass">
        <Column selectionMode="multiple" style="width: 3rem" :exportable="false"></Column>
        <Column field="code" header="Pdr" :sortable="true"></Column>
        <Column field="data_inizio" header="Data Inizio" :sortable="true">
          <template #body="{data}">
            {{formatDate(data.data_inizio)}}     
          </template>
        </Column>
        <Column field="data_fine" header="Data fine" :sortable="true">
          <template #body="{data}">
            {{formatDate(data.data_fine)}}     
          </template>
        </Column>
        <Column field="cliente" header="Cliente" :sortable="true"></Column>
        <Column field="stato_interno" header="Stato Interno" :sortable="true"></Column>
        <Column field="cc" header="CC" :sortable="true"></Column>
        <Column field="udd" header="UDD" :sortable="true"></Column>
        <Column field="disalimentabile" header="Disalimentabile" :sortable="true">
          <template #body="{data}">
            <p v-if="data.disalimentabile == 'N'">No</p>
            <p v-else-if ="data.disalimentabile == 'Y'">Si</p>
          </template>
        </Column>
    </DataTable>

  </div>
  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        />
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import { ref, getCurrentInstance, onMounted } from 'vue';
import Service from '@/services/ask-operation/operation-service'
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },
    
  setup(props) {
    const page = { name: 'pdrs-sospensioni-riattivazioni'}
    const loader = ref(false)
    const toast = useToast();

    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const formatDate = self.appContext.config.globalProperties.$formatDate
    const service = new Service(self.$http, self.$eventBus)
    const filters = ref({
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
    });

    const items = ref(props.data.ids)
    const type= ref(props.data.type)
    const selectedItems = ref(items.value);

    onMounted(() => {
      if (items.value.length > 0) {
        items.value.forEach(el => {
          el.error = false
        });
      }
    })
      
    const onOkButton = () => {
      toast.removeGroup(page.name);

      if (Object.entries(selectedItems.value).length !== 0) {
        loader.value = true
        service.sospendi_riattiva_pdrs(selectedItems.value, type.value)
        .then((res) => {
          if (Object.keys(res.items.fornitori_not_configured).length > 0) {
            for (const objs of Object.values(res.items.fornitori_not_configured)) {
              objs.forEach(obj => {
                const objFound = items.value.find(e => e.id === obj.id);
                if (objFound) {
                  objFound.error = true;
                }
              });
            }
           toast.add({severity:'warn', summary: 'Attenzione', detail:'Alcuni fornitori non configurati', group: page.name});
          }
        })
        .finally(()=>{
          loader.value = false
          _reset()
          self.$eventBus.emit(`dialog-return-ok-button`, {}) 
        })
      } else {
        toast.add({severity:'warn', summary: 'Attenzione', detail:'Non hai selezionato nessun elemento', group: page.name});
      }
    }


    const onCancelButton = () => {
      _reset()
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }

    const _reset = () =>{
      selectedItems.value = []
    }

    const rowClass = (data) => {
      return data.error == true ? 'p-error' : ''
    };


    return {
      page,
      filters,
      items,
      type,
      selectedItems,
      loader,
      onOkButton,
      onCancelButton,
      formatDate,
      moment,
      rowClass,
    }
  }
}


</script>

<style scoped>
::v-deep(.p-error) {
    background-color: #ffa9b1 !important;
}
</style>
